import Swiper from "swiper/bundle";
import constants from "../lib/constants";

export default class {
  constructor(element) {
    if (!element) {
      return false;
    }

    this.wrap = jQuery(element);
    

    this._iniSlider()
    console.log('this.wrap', this.wrap)

  //  this._checkBreakpoint();   
   
    // jQuery(window).on("resize", () => {
    //   this._checkBreakpoint();
    // });
  }

  // _checkBreakpoint() {
  //   if (jQuery(window).width() < 992) {    
  //     if (!this.swiper) {
  //       this._iniSlider();
  //     }
  //   } else if (this.swiper) {
  //     this.swiper.destroy(true, true);
  //     this.swiper = null;
  //   }
  // }

  _iniSlider() {
    this.swiper = new Swiper(this.wrap[0], {    
      spaceBetween:20,     
      autoplay: {
        delay: 4000,
      },
      pagination: {       
        clickable: true,
        el: ".s-programs__mob .swiper-pagination",
      },
      breakpoints: {
        320:{
          slidesPerView:1
         },
         780:{
          slidesPerView:3
         },
        1520: {
          slidesPerView: "auto",
        },
      },
    });
  }
}
